import { render, staticRenderFns } from "./appointment-grid-details-row.vue?vue&type=template&id=32abebe0&scoped=true"
import script from "./appointment-grid-details-row.vue?vue&type=script&lang=js"
export * from "./appointment-grid-details-row.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32abebe0",
  null
  
)

export default component.exports